module.exports = __webpack_public_path__ + "img/wtb2.7e5e2f4e.png";